// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1707029254536
      var cssReload = require("/home/jenkins/jenkins_home/workspace/develop_shop-b2b/vue-yiqitong/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  